import { ApolloError } from '@apollo/client';

import { LinkItem } from '@occc-app/design-system';

const getOfferName = (loading: boolean, name?: string, error?: ApolloError): string | null => {
  if (error) {
    return null;
  }

  if (loading && !name) {
    return 'Loading...';
  }

  if (!name) {
    return null;
  }
  return name;
};

export const getOfferDetailsPageHeaderLinks = (
  loading: boolean,
  offerName?: string,
  error?: ApolloError,
): LinkItem[] => [
  {
    to: '/offers',
    label: 'Offers',
  },
  {
    key: '/offers/offer-name',
    label: getOfferName(loading, offerName, error),
  },
];
